package de.connect2x.timmy

import de.connect2x.lognity.api.logger.Logger
import de.connect2x.timmy.customcomponents.customComponentsModule
import de.connect2x.trixnity.clientserverapi.client.MatrixClientAuthProviderData
import de.connect2x.trixnity.core.model.UserId
import de.connect2x.trixnity.messenger.compose.view.composeViewModule
import de.connect2x.trixnity.messenger.compose.view.typography.nunito.addNunitoThemeTypography
import de.connect2x.trixnity.messenger.extensions.tim.IsTIMCheck
import de.connect2x.trixnity.messenger.extensions.tim.TIMConfiguration
import de.connect2x.trixnity.messenger.extensions.tim.TIMSpec
import de.connect2x.trixnity.messenger.extensions.tim.addTIMModule
import de.connect2x.trixnity.messenger.extensions.tim.compose.platformTimStartupModule
import de.connect2x.trixnity.messenger.extensions.tim.compose.timViewModuleFactory
import de.connect2x.trixnity.messenger.extensions.tim.util.forceRedactionWarning
import de.connect2x.trixnity.messenger.i18n.DefaultLanguages
import de.connect2x.trixnity.messenger.i18n.I18n
import de.connect2x.trixnity.messenger.i18n.Languages
import de.connect2x.trixnity.messenger.i18n.platformGetSystemLangModule
import de.connect2x.trixnity.messenger.multi.MatrixMultiMessengerConfiguration
import de.connect2x.trixnity.messenger.platformMatrixMessengerSettingsHolderModule
import de.connect2x.trixnity.messenger.util.RootPath
import io.ktor.http.*
import org.koin.dsl.module

private val log = Logger {}

fun MatrixMultiMessengerConfiguration.timmyConfiguration(
    timSpec: TIMSpec = BuildConfig.spec,
    overrideVzdUrl: Url? = null,
    overrideIdpUrl: Url? = null,
    overrideVersionCheckUrl: Url? = null,
    overrideHomeServerUrl: String? = null,
    disableDownloads: Boolean,
    customTIMConfig: TIMConfiguration.() -> Unit = {},
    branding: Brand,
    ) {
    log.info { "Configuring TI-Messenger $timSpec running in ${BuildConfig.flavor}" }
    val notificationsDebugEnabled = BuildConfig.flavor == Flavor.DEV
    appName = branding.appName
    appId = BuildConfig.appId
    appUri = "$appId:"
    appIcon = "status_icon.png"
    oAuth2ClientUrl = "https://timmy.connect2x.de"
    privacyInfo = Constants.PRIVACY_LINK
    imprint = Constants.IMPRINT_LINK
    licenses = BuildConfig.licenses
    // sendLogsEmailAddress = ""
    modulesFactories += listOf(
        { composeViewModule(null) },
        // TODO this needs to be removed and fixed, as there is no MatrixMessengerSettingsHolderImpl at MultiMessenger level!
        ::platformMatrixMessengerSettingsHolderModule,
        // TODO there should be a more clean way for I18n
        ::platformGetSystemLangModule,
        {
            module {
                single<Languages> { DefaultLanguages }
                single<I18n> { object : I18n(get(), get(), get(), get()) {} }
            }
        },
        timViewModuleFactory(timSpec),
        branding.themeModule,
    )

    messengerConfiguration messengerConfig@{
        // needed for TIM
        defaultPresenceIsPublic = false
        defaultReadMarkerIsPublic = false
        defaultTypingIsPublic = false
        useRefreshTokens = true

        if (forceRedactionWarning(timSpec)) {
            defaultRedactionWarningIsEnabled = true
        }

        modulesFactories += listOf(
            { composeViewModule(this) },
            timViewModuleFactory(timSpec),
            branding.themeModule,
            ::platformTimStartupModule
        )
    }

    addTIMModule(timSpec) {
        version = BuildConfig.version
        clientId = "AKQPROWA"
        productAbbreviation = "AKQPROWA"
        manufacturerId = "AKNET"
        versionCheckUrl = overrideVersionCheckUrl

        // TIMConfiguration flavors
        when (BuildConfig.flavor) {
            Flavor.PROD -> {
                vzdUrl = overrideVzdUrl ?: TIMConfiguration.DefaultVzdUrls.production
                idpUrl = overrideIdpUrl ?: TIMConfiguration.DefaultIdpUrls.production
            }

            Flavor.REF -> {
                vzdUrl = overrideVzdUrl ?: TIMConfiguration.DefaultVzdUrls.reference
                idpUrl = overrideIdpUrl ?: TIMConfiguration.DefaultIdpUrls.reference
            }

            Flavor.DEV -> {
                vzdUrl = overrideVzdUrl ?: TIMConfiguration.DefaultVzdUrls.reference
                idpUrl = overrideIdpUrl ?: TIMConfiguration.DefaultIdpUrls.reference
                disableFederationCheck = true
                // TODO needs to be updated every 30 days
//                customVzdSearchAccessToken =
//                    "eyJhbGciOiJIUzI1NiJ9.eyJleHAiOjE3NTMzMzk2NjMsInVzZXJuYW1lIjoibXRoaWVsZSJ9.33QoClnbzm-peQfs-kNJjY050aFjDQMIfmmPOV1CvNI"
                messengerProxyBaseUrl = Url("http://localhost:3000")
            }
        }

        customTIMConfig()
    }

    when (BuildConfig.flavor) {
        Flavor.PROD, Flavor.REF -> {}
        Flavor.DEV -> {
            modulesFactories += {
                module {
                    val devRootPath = getDevRootPath()
                    if (devRootPath != null) single<RootPath> { devRootPath }
                }
            }
        }
    }

    messengerConfiguration {
        when (BuildConfig.flavor) {
            Flavor.PROD -> {}
            Flavor.REF -> {}
            Flavor.DEV -> {
                defaultHomeServer = "matrix.dev.connect2x.de"
                httpClientConfig = null // no tim headers or TLS restrictions
                modulesFactories += {
                    module {
                        single<IsTIMCheck> {
                            object : IsTIMCheck {
                                override suspend fun invoke(
                                    userId: UserId,
                                    matrixClientAuthProviderData: MatrixClientAuthProviderData
                                ): Boolean {
                                    return userId.domain == "matrix.dev.connect2x.de"
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    messengerConfiguration {
        downloadsDisabled = disableDownloads
        defaultHomeServer = overrideHomeServerUrl
        features.enablePdfReader = false
        modulesFactories += listOf(::customComponentsModule)
    }

    addNunitoThemeTypography()
}

internal expect fun getDevRootPath(): RootPath?
